import { JsonApiRequestError } from '@farfetched/core';
import { createWalletRegistryQuery, WalletDetailed, WalletRegistryFilters } from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel } from 'shared/lib';
import { authorizedAccountRoute } from 'shared/routing';

export type WalletRegistryModel = RegistryModel<
	WalletDetailed,
	WalletRegistryFilters,
	JsonApiRequestError
>;

export const createWalletRegistryModel = (params: RegistryCallbacks): WalletRegistryModel => {
	const query = createWalletRegistryQuery(
		authorizedAccountRoute.$query.map(({ id }) => id ?? null),
	);

	const model = createRegistryModel({
		query,
		filters: {},
		sortField: 'currency',
		...params,
	});

	return model;
};
